// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2BQ-f","footer":"ChangeClinic_footer__1NVs9"};